var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.076 16.254 2.102 2.584 1.931-2.584v4.118h1.902c.483 0 1.221-.397 1.221-1.05V11H8.11l-1.932 3.18L4.076 11H1.038c-.029 2.395-.069 7.413 0 8.321.068.91.823 1.08 1.192 1.052h1.846v-4.118z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.783 11.142h-2.67c0 1.505.2 1.732.626 1.732.425 0 1.02.086 1.59 0 .453-.068.491-1.183.453-1.732z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.114 19.037v-5.083c1.022-.432 2.205-.18 2.67 0v5.083c0 .682-.285 1.335-1.392 1.335-.886 0-1.221-.89-1.278-1.335z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.89 19.321v-8.178h2.614c-.123 2.064-.295 6.237 0 6.418.295.182 1.108.19 1.477.17v2.642h-2.754c-1.045 0-1.325-.7-1.335-1.05z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.861 19.89c-.044.454.512.51.796.482a.56.56 0 0 0 .256-.483c0-.341 0-.569-.426-.569-.426.001-.568.001-.625.57z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.963 19.037v-7.895h2.953v4.033l1.903-2.3H31l-2.357 3.265 2.073 4.232c-.87.047-2.71.114-3.096 0-.386-.114-.88-1.297-1.079-1.874a1.514 1.514 0 0 0-.624.54c-.181.295-.075 1.012 0 1.334h-1.533c-.977 0-1.354-.89-1.42-1.335z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlk);
export default __webpack_public_path__ + "static/media/MLK.c2726b8b826bbcd8b4850d02210fa4f1.svg";
export { ForwardRef as ReactComponent };